// Public browser configuration only. Shared by deployment and startup.
const requiredKeys = [
  'REACT_APP_HTTP_PROXY_URL',
  'REACT_APP_PROXY_URL',
  'REACT_APP_ENTRA_CLIENT_ID',
  'REACT_APP_ENTRA_AUTHORITY',
  'REACT_APP_ENTRA_KNOWN_AUTHORITY',
  'REACT_APP_ENTRA_API_SCOPE',
  'REACT_APP_ENTRA_REDIRECT_URI',
  'REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI',
];
const optionalKeys = ['REACT_APP_ENTRA_MAIN_APP_CLIENT_ID'];
const uuid = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';

function validateRuntimeConfig(value, origin) {
  if (!value || Array.isArray(value) || typeof value !== 'object' || value.version !== 1)
    throw new Error('Unsupported runtime configuration');
  if (!['main', 'requests'].includes(value.surface)) throw new Error('Invalid client surface');
  const allowed = new Set(['version', 'surface', ...requiredKeys, ...optionalKeys]);
  if (Object.keys(value).some((key) => !allowed.has(key)))
    throw new Error('Unexpected runtime configuration field');
  for (const key of requiredKeys) {
    if (typeof value[key] !== 'string' || !value[key] || /[<>\s]/.test(value[key]))
      throw new Error(`Missing or invalid ${key}`);
  }
  if (!new RegExp(`^${uuid}$`, 'i').test(value.REACT_APP_ENTRA_CLIENT_ID))
    throw new Error('Invalid identity client ID');
  if (
    !new RegExp(`^api://${uuid}/[A-Za-z0-9._~-]{1,128}$`, 'i').test(value.REACT_APP_ENTRA_API_SCOPE)
  )
    throw new Error('Invalid identity API scope');
  const url = (key) => {
    const result = new URL(value[key]);
    if (
      result.protocol !== 'https:' ||
      result.username ||
      result.password ||
      result.search ||
      result.hash
    )
      throw new Error(`Invalid HTTPS URL for ${key}`);
    return result;
  };
  for (const key of ['REACT_APP_HTTP_PROXY_URL', 'REACT_APP_PROXY_URL']) {
    if (url(key).pathname !== '/') throw new Error('API URLs must be plain origins');
  }
  const authority = url('REACT_APP_ENTRA_AUTHORITY');
  if (authority.hostname !== value.REACT_APP_ENTRA_KNOWN_AUTHORITY || authority.pathname === '/')
    throw new Error('Identity authority must match its trusted hostname and tenant');
  const callback = url('REACT_APP_ENTRA_REDIRECT_URI');
  const logout = url('REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI');
  if (
    callback.pathname !== '/auth/callback' ||
    logout.pathname !== '/' ||
    callback.origin !== logout.origin
  )
    throw new Error('Invalid authentication redirect URLs');
  if (origin && callback.origin !== origin)
    throw new Error('Runtime configuration belongs to another site');
  if (
    value.surface === 'requests' &&
    (!new RegExp(`^${uuid}$`, 'i').test(value.REACT_APP_ENTRA_MAIN_APP_CLIENT_ID ?? '') ||
      value.REACT_APP_ENTRA_MAIN_APP_CLIENT_ID.toLowerCase() ===
        value.REACT_APP_ENTRA_CLIENT_ID.toLowerCase())
  )
    throw new Error('Requests requires a separate identity registration');
  return Object.freeze({ ...value });
}

export { requiredKeys, optionalKeys, validateRuntimeConfig };
